module.exports = __webpack_public_path__ + "img/15.90b93ab0.jpg";